// extracted by mini-css-extract-plugin
export var centeredWithMaxWidth = "DocPage-module--centered-with-max-width--ca717";
export var container = "DocPage-module--container--5559f";
export var markDownSection = "DocPage-module--mark-down-section--6cb80";
export var sideNavSection = "DocPage-module--side-nav-section--f6a68";